// Robust parser for plan.amount strings coming from the backend.
// Mirrors backend/src/services/CompanyService/parsePlanAmount.ts — keep in
// sync. Accepts any of:
//   "1594.80"  -> 1594.80
//   "1594,80"  -> 1594.80
//   "1.594,80" -> 1594.80   (BR thousands + comma decimal)
//   "1,594.80" -> 1594.80   (US thousands + period decimal)
const parsePlanAmount = (raw) => {
  if (raw === null || raw === undefined) return 0;
  if (typeof raw === "number") return Number.isFinite(raw) ? raw : 0;

  const s = String(raw).trim();
  if (!s) return 0;

  const hasComma = s.includes(",");
  const hasDot = s.includes(".");

  let normalized;
  if (hasComma && hasDot) {
    normalized =
      s.lastIndexOf(",") > s.lastIndexOf(".")
        ? s.replace(/\./g, "").replace(",", ".")
        : s.replace(/,/g, "");
  } else if (hasComma) {
    normalized = s.replace(",", ".");
  } else {
    normalized = s;
  }

  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
};

export default parsePlanAmount;
